// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YFG65","column":"styles_column__52BCZ"};